import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent, NgNotFoundTemplateDirective, NgFooterTemplateDirective, NgHeaderTemplateDirective } from '@ng-select/ng-select';
import { LookupService } from '../../../../core/services/lookup.service';
import { LookupKey } from '../../../constants/lookup-keys';
import { ActivitiesResponseModel, IndustryActivityRaw } from '../../../models/activities-response.model';
import { MultiSelectOption } from '../../../models/select-option.model';
import { PagenationComponent } from "../../pagenation/pagenation.component";
import { ButtonComponent } from "../../button/button.component";


@Component({
  selector: 'app-searchable-list',
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule, // ngModel
    NgSelectComponent, // the picker itself
    NgLabelTemplateDirective, // templates you’re using
    NgOptionTemplateDirective,
    NgNotFoundTemplateDirective,
    NgFooterTemplateDirective,
    PagenationComponent,
    NgHeaderTemplateDirective,
    ButtonComponent
  ],
  templateUrl: './searchable-list.component.html',
  styleUrl: './searchable-list.component.css'
})

export class SearchableListComponent implements OnChanges {

  @ViewChild('selectElement2') selectElement2!: NgSelectComponent;
  @Input() label: any;
  @Input() control!: any;
  @Input() selectedItems: any[] = [];
  @Input() validationMessages: { [key: string]: string } = {};
  @Input() placeholder: string = '';
  @Input() errorMessage: string = 'This field is required';
  @Input() options: MultiSelectOption[] = [];
  @Output() onAdd = new EventEmitter<any>();
  @Output() onRemove = new EventEmitter<any>();
  @Output() onViewClick = new EventEmitter<any>();
  @Output() addNewItem = new EventEmitter<any>();
  @Input() labelKey: string = "name";
  @Input() valueKey: string = "name";

  @Input() otherActionText: string = "";
  @Input() lovType: string = "";
  @Input() allowAddNew: boolean = false;
  @Input() notFoundText: string = "";
  @Input() showAction: boolean = true;


  @Input() loading: boolean = true;
  @Input() showSelectedItemsList: boolean = true;

  @Input() noOfTotalRecords: number = 0;
  @Input() showPageNation: boolean = false;
  @Input() noOfRecordPerPage = 4;
  @Input() allowAddMultiple: boolean = true;
  @Input() showMemberFilter: boolean = false;


  @Output() search = new EventEmitter<any>();
  @Output() onPageChange = new EventEmitter<any>();
  @Output() onSelectionClear = new EventEmitter<any>();

  searchBy: string = 'CSN'; // default option { "value": "MemberName", "label": "SEARCH_BY_MEM_NAME" }, 
  searchByOptions: any = [{ "value": "CSN", "label": "SEARCH_BY_MEM_NUMBER" }, { "value": "LicenseNumber", "label": "SEARCH_BY_MEM_LICENSE" }]
  @ViewChild('ngSelect') ngSelect!: NgSelectComponent;

  searchQuery = '';
  pageSize = 4;
  currentPage = 1;
  searchTerm: string = '';
  showDropdown: boolean = true;
  searchText: string = "";
  get isRequired(): boolean {
    const hasRequired = this.control?.hasValidator?.(Validators.required);
    const hasRequiredTrue = this.control?.hasValidator?.(Validators.requiredTrue);
    return Boolean(hasRequired || hasRequiredTrue);
  }
  // This method is used to initialize the class instance using lookup service
  constructor(
    private lookupService: LookupService
  ) {

  }
  // This method is used to handle the on changes lifecycle hook using changes
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['lovType'] && this.lovType) {
      this.loadOptions('');
    }
  }

  // This method is used to load options using parent value
  loadOptions(parentValue: string) {
    this.lookupService
      .post<ActivitiesResponseModel>(LookupKey.ACTIVITIES_URL, {
        "ProcessName": "DC Get Activity Code List Mob App WF",
        "SRC": "",
        Type: this.lovType
      })
      .subscribe({
        // This method is used to handle the next callback using result
        next: (result: ActivitiesResponseModel) => {
          this.loading = false;
          if (result.SiebelMessage?.Industry) {
            // this.options = result.SiebelMessage?.Industry;
            this.options = this.mapToCamelCaseActivities(result.SiebelMessage?.Industry);
          }
        },
        // This method is used to handle the error callback using e
        error: (e) => {
          this.loading = false;
        }
      });
  }
  // This method is used to error keys
  get errorKeys(): string[] {
    return this.control?.errors ? Object.keys(this.control.errors) : [];
  }
  // This method is used to compare with using a and b
  compareWith = (a: any, b: any) => String(a) === String(b);

  // This method is used to add item using item
  addItem(item: any) {
    if (this.allowAddMultiple == true) {
      const existingIndex = this.selectedItems.findIndex((o: any) => o.code === item.code);
      if (this.selectedItems.length > 0 && existingIndex !== -1) {
        this.selectedItems[existingIndex] = item;
      } else {
        this.selectedItems.push(item);
      }
    }
    else {
      this.selectedItems = [item]
    }
    this.onAdd.emit(this.selectedItems);
    if (this.selectElement2) {
      this.selectElement2.close(); // closes the dropdown
    }
  }
  // This method is used to remove item using item
  removeItem(item: any) {
    // Find the item and mark it as removed with an endDate
    const index = this.selectedItems.findIndex((a: any) => a === item);
    if (index !== -1) {
      if (this.selectedItems[index]?.accountActivityId) {
        this.selectedItems[index] = {
          ...this.selectedItems[index],
          endDate: new Date(),
        };
      } else {
        this.selectedItems.splice(index, 1);
      }
    }
    // Filter only active items without endDate)
    const activeItems = this.selectedItems; //.filter((x: any) => !x.endDate);

    if (activeItems.length < 5) {
      this.currentPage = 1;
      this.pagedItems;
    }
    this.onRemove.emit(this.selectedItems);
  }

  activateItem(item: any) {
    const index = this.selectedItems.findIndex((a: any) => a === item);
    if (index !== -1) {
      const updatedItem = { ...this.selectedItems[index] };
      delete updatedItem.endDate;
      this.selectedItems[index] = updatedItem;
      this.onAdd.emit(this.selectedItems);
    }
  }

  // This method is used to custom search using term and item
  customSearch(term: string, item: any): boolean {
    let search = term?.toLowerCase() ?? "";
    const name = item.name?.toLowerCase() ?? "";
    const description = item.description?.toLowerCase() ?? "";
    const code = item.code?.toString().toLowerCase() ?? "";
    // return name.includes(term) || description.includes(term) || code.includes(term);
    return (
      name.startsWith(search) ||
      description.startsWith(search) ||
      code.startsWith(search)
    );
  }

  // This method is used to filter ed
  get filtered() {
    return this.selectedItems.filter(i =>
      (i.code + i.name + (i.description ?? ''))
        .toLowerCase()
        .includes(this.searchQuery.toLowerCase())
    );
  }

  // This method is used to total pages
  get totalPages() { return Math.ceil(this.filtered.length / this.pageSize); }
  // This method is used to paged items
  get pagedItems() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.filtered.slice(start, start + this.pageSize);
  }

  // This method is used to map to camel case activities using raw
  mapToCamelCaseActivities(raw: IndustryActivityRaw[]): MultiSelectOption[] {
    return raw.map((item: any) => ({
      type: item.Type,
      codeFee: item['DC Activity Code Fee'],
      description: item['DC Description Arabic'],
      code: item['SIC Code'],
      name: item.Description,
      descriptionOtherEn: item['DC Special Act Code Eng'],
      descriptionOtherAr: item['DC Special Act Code Ara'],
    }));
  }
  // This method is used to open add form using data
  openAddForm(data = "") {
    this.addNewItem.emit(data);
  }
  // This method is used to handle type event using term
  onType(term: any) {
    this.search.emit(term);
  }

  // This method is used to focus
  focus(): void {
    // const el = this.selectElement2?.nativeElement;
    // if (el) {
    //   el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    //   el.focus();
    // }
  }

  // This method is used to total option pages
  get totalOptionPages() { return Math.ceil(this.noOfTotalRecords / this.noOfRecordPerPage); }
  optionCurrentPage = 1;
  // This method is used to load page using page
  loadPage(page: any) {
    this.optionCurrentPage = page; //this.optionCurrentPage;
    this.onPageChange.emit(page);
  }
  // This method is used to handle cleared event
  onCleared() {
    this.onSelectionClear.emit();
  }

  // Trigger search reset when dropdown closes (e.g., user clicks outside)
  onDropdownClosed() {
    if (!this.showMemberFilter) {
      this.onSelectionClear.emit();
    }
  }


  // This method is used to handle search by change event
  onSearchByChange() {
    this.search.emit({
      searchBy: this.searchBy,
      searchText: this.control?.value
    });
  }
  // This method is used to search member using event
  searchMember(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    if (this.searchText.length >= 2) {
      this.search.emit({
        searchBy: this.searchBy,
        searchText: this.searchText
      });
    }
  }

  onOptionSelected(event: any) {
    if (event?.code || event?.name) {
      this.addItem(event);
    }
    if (this.showAction) {
      return
    }
    if (event) {
      this.addItem(event)
    } else {
      this.control.setValue(null); // reset if selected normally
    }
  }
  isCalledToSearch: boolean = false;
  onSearchClick() {
    if (this.searchText && this.searchText.trim().length >= 2) {
      this.isCalledToSearch = true;
      this.search.emit({
        searchBy: this.searchBy,
        searchText: this.searchText.trim()
      });
    } else {
      // You can show a message or ignore
    }
  }
  onClearClick() {
    this.searchText = '';
  }
}
